let id = 1;

const generateId = () => {
  id = id + 1;
  return id;
};

export const useId = () => {
  return generateId();
};
